import React from 'react';
import { PortCallsPage as SharedPortCallsPage } from '../../port-calls';

/** Module-scoped supplies port calls (tree filtered to supplies only). */
export const PortCallsPage: React.FC = () => <SharedPortCallsPage scope="supplies" />;

export default PortCallsPage;
